/* eslint-disable prettier/prettier */
const initialState = {
    data:null,
    
};
const initialState1 = {
    chats : null
};

export const selectedChatReducer = (state = initialState,{type,payload}) =>{
    switch(type){
        case 'SET_SELECTED_CHATS':
            return {...state,data : payload}
        default : 
            return state   
    }
}

export const chatsReducer = (state = initialState1,{type,payload}) =>{
    switch(type){
        case 'SET_CHATS':
            return {...state,chats : payload}
        default : 
            return state   
    }
}

